import { WatchList } from '@/api';
import NSwitch from '@/uikit/switch/NSwitch.vue';
import { ITableColumn } from '@/uikit/table/NTable.vue';
import NTableColumnCell from '@/uikit/table/NTableColumnCell.vue';
import ButtonModelCopy from '@/components/common/ButtonModelCopy.vue';
import { WatchListItemTextTypes } from '@/components/common/watch-list-types';
import WatchListItem from '@/components/common/WatchListItem.vue';
import WatchListTableItem from '@/pages/watch-lists/WatchListTableItem.vue';

export const columns: ITableColumn[] = [
  {
    width: 'max-content',
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'common.id'
      }
    },
    content: {
      path: 'id',
      component: ButtonModelCopy
    }
  },
  {
    header: {
      classes: ['bottom-border'],
      component: NTableColumnCell,
      props: {
        i18n_label: 'common.column_name',
        name: 'name',
        sortable: true
      }
    },
    content: {
      path: 'name',
      component: WatchListTableItem
    }
  },
  {
    width: '110px',
    header: {
      classes: ['align-right', 'bottom-border'],
      component: NTableColumnCell,
      props: { i18n_label: 'common.column_active' }
    },
    content: {
      path: 'active',
      classes: ['align-right'],
      component: NSwitch,
      props: (item: WatchList) => ({ disabled: item.id === -1 })
    }
  }
];
